import axios from "../../config/axiosConfig";
import { GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS, RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST, RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE, 
  GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_TAKA_NO } from "../types";

export const getRawMaterialInwardChallanTransaction = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/raw-material-inward-challan-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRawMaterialInwardChallanTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/raw-material-inward-challan-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => ({
          Taka_No: data.Taka_No,
          // Book_Id: data?.RawMaterialInwardChallan?.Book_Id,
          Account_Id: data?.RawMaterialInwardChallan?.Account_Id,
          // Type: data?.RawMaterialInwardChallan_Type,
          Voucher_No: data?.RawMaterialInwardChallan?.Vch_No,
        }));
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};